import React, { useState } from "react"
import {
  Button,
  Menu,
  MenuItem,
  FormControlLabel,
  Box,
  Typography,
  Divider,
  Radio
} from "@mui/material"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"

const HighLowSelect = ({ items = [], selectedItems = [], setSelectedItems }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const getItemSensitivity = _id => {
    return selectedItems?.find(item => item._id === _id)?.senstivity || null
  }

  const toggleItem = item => {
    setSelectedItems(prev => {
      const current = prev.find(i => i._id === item._id)?.senstivity
      if (!current) {
        return [...prev, { _id: item._id, senstivity: "HG" }]
      }
      return prev.filter(i => i._id !== item._id)
    })
  }

  const selectLevel = (item, level) => {
    setSelectedItems(prev => {
      const exists = prev.find(i => i._id === item._id)
      if (!exists) {
        return [...prev, { _id: item._id, senstivity: level }]
      }
      return prev.map(i => (i._id === item._id ? { ...i, senstivity: level } : i))
    })
  }

  const getDisplayText = () => {
    if (!selectedItems || selectedItems.length === 0) return "Select items..."
    return selectedItems
      .map(({ _id, senstivity }) => {
        const name = items.find(i => i._id === _id)?.name || _id
        return `${name} (${senstivity})`
      })
      .join(", ")
  }

  return (
    <>
      <Button
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
        size="large"
        className="custom-dropdown-btn"
        sx={{
          maxWidth: 350,
          height: 57,
          justifyContent: "space-between",
          borderRadius: "6px",
          border: "1px solid #ccc",
          backgroundColor: "white",
          padding: "10px 14px",
          boxShadow: "none",
          textAlign: "left",
          "&:hover": {
            backgroundColor: "#f9f9f9",
            boxShadow: "none"
          }
        }}
      >
        <Typography
          noWrap
          sx={{
            maxWidth: "80%",
            textOverflow: "ellipsis",
            overflow: "hidden",
            color: "black"
          }}
        >
          {getDisplayText()}
        </Typography>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{ sx: { width: 300, maxHeight: 400 } }}
      >
        {items.map((item, index) => {
          const selected = getItemSensitivity(item._id)

          return (
            <Box key={item._id}>
              <MenuItem
                disableRipple
                onClick={() => toggleItem(item)}
                sx={{
                  display: "block",
                  alignItems: "flex-start",
                  px: 2,
                  py: 1,
                  backgroundColor:
                    selected === "HG" ? "#ffebee" : selected === "MD" ? "#fff8e1" : "inherit",
                  "&:hover": {
                    backgroundColor:
                      selected === "HG" ? "#ffcdd2" : selected === "MD" ? "#ffecb3" : "#f5f5f5"
                  }
                }}
              >
                <Typography sx={{ fontWeight: 500 }}>{item.name}</Typography>

                <Box sx={{ display: "flex", justifyContent: "space-around", mt: 1 }}>
                  <FormControlLabel
                    control={
                      <Radio
                        size="small"
                        checked={selected === "HG"}
                        onClick={e => {
                          e.stopPropagation()
                          selectLevel(item, "HG")
                        }}
                        sx={{ color: "red", "&.Mui-checked": { color: "red" } }}
                      />
                    }
                    label="High"
                    sx={{ margin: 0 }}
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        size="small"
                        checked={selected === "MD"}
                        onClick={e => {
                          e.stopPropagation()
                          selectLevel(item, "MD")
                        }}
                        sx={{ color: "orange", "&.Mui-checked": { color: "orange" } }}
                      />
                    }
                    label="Low"
                    sx={{ margin: 0 }}
                  />
                </Box>
              </MenuItem>
              {index < items.length - 1 && <Divider />}
            </Box>
          )
        })}
      </Menu>
    </>
  )
}

export default HighLowSelect
